import { ChangeEvent, FC } from 'react';
import CustomSelect from '../../../common/CustomSelect';

interface DuplicatePaymentInputFieldProps {
  onChange: (value: number) => void;
  value: string | number;
  disabled?: boolean;
  maxDuplication: number;
}

const DuplicatePaymentInputField: FC<DuplicatePaymentInputFieldProps> = (
  props
) => {
  const { value, disabled, maxDuplication, onChange } = props;

  const options = Array.from({ length: maxDuplication - 1 }, (_, index) => {
    const numString = (index + 2).toString();
    return { label: numString, value: numString };
  });

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    onChange(parseInt(value));
  };

  return (
    <div className={`mx-auto w-11/12 text-left`}>
      <div className="flex justify-between">
        <label htmlFor="name" className="text-sm font-semibold w-full mr-auto">
          Veces a pagar:
        </label>
      </div>
      <CustomSelect
        id=""
        placeholder="1"
        name=""
        value={value}
        handleChange={
          handleChange as (e: ChangeEvent<HTMLSelectElement>) => void
        }
        options={options}
        disabled={disabled}
      />
    </div>
  );
};

export default DuplicatePaymentInputField;
